import { render, staticRenderFns } from "./DiySkeleton.vue?vue&type=template&id=3c6e0e00&"
import script from "./DiySkeleton.vue?vue&type=script&lang=js&"
export * from "./DiySkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports